import angular from 'angular';

import gridHeight from '../../../core/shared-service/grid-utils';

class PrincipalGroupSubEntityCtrl {
  /*@ngInject*/
  constructor(PrincipalSvc, $state, logger, $uibModal,$translate) {
    this.PrincipalSvc = PrincipalSvc;
    this.translate = $translate;
    this.$state = $state;
    this.logger = logger;
    this.$uibModal = $uibModal;
  }

  $onInit() {
    this.includes = {
      headerTemplate: require('../../principal-header-info.html'),
      errorMessages: require('../../../layouts/error-messages.html')
    };
    var ctrl = this;

  
    var deleteCellTemplate =
      '<div class="ui-grid-cell-contents text-center pointer"' +
      'ng-click="grid.appScope.$ctrl.deleteSubEntity(row.entity)"><span><i class="fa fa-trash"></i></span>&nbsp;</div>';

    // Gestion de la grille
    this.gridOptions = {
      columnDefs: [
        { name: 'name', displayName: 'Nom établissement', sort: { direction: 'asc', priority: 0 } },
        { name: 'code', displayName: 'ID' },
        { name: 'getAddress()', displayName: 'Adresse' },
        { name: ' getCountryLabel()', displayName: 'Pays' },
        { name: 'getStatusLabel()', displayName: 'Statut' },
        { name: 'delete', displayName: '', width: '50', cellTemplate: deleteCellTemplate, enableSorting: false }
      ],
      paginationPageSize: 10,
      paginationPageSizes: [10, 50],
      enableSorting: true,
      enableGridMenu: false,
      enableColumnMenus: false,
      onRegisterApi: function(gridApi) {
        ctrl.gridApi = gridApi;
      }
    };
    this.initCriteria();
  }

  /**
   * initialise le tableau avec les sociétés.
   */
  initCriteria() {
    this.groupId = this.group.id;
    if (!this.creation) {
      this.gridOptions.data = this.group.subEntities;
      this.criteria = {};
      this.criteria.name = this.group.name;
      this.criteria.description = this.group.description;
      this.subEntityCompanyName = this.group.subEntities[0].legalEntity.name;
    }
  }

  save() {
    if (this.form.$valid) {
      if (this.gridOptions.data.length === 0) {
        this.logger.error('principal.group.creation.group_one_company_min');
        return;
      }

      this.criteria.subEntities = this.gridOptions.data;
      this.criteria.legalEntities= this.group.companies;
      this.criteria.id = this.groupId;
      this.criteria.principalId = this.principal.detail.id;
      var promise = this.creation
        ? this.PrincipalSvc.createGroupSubEntity(this.criteria)
        : this.PrincipalSvc.updateGroupSubEntity(this.criteria);
       
      promise.then(
        () => {
          var msg = this.creation ? 'principal.group.creation_success' : 'principal.group.update_success';
          this.logger.success(msg);
          this.$state.go('app.principal.consult.group');
        },
        () => {
            var msg = this.creation ? 'error.create' : 'error.update';
            this.logger.error(msg);
        },
        () => {
          this.criteria.companies = [];
        }
      );
    }
  }

  /**
   * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
   */
  getGridHeight() {
    return gridHeight(this.gridApi);
  }

  openModalSubEntity() {
    var ctrl = this;
    this.$uibModal
      .open({
        component: 'modal-group-add-sub-entity',
        size: 'lg',
        resolve: {
          currentSubEntities: function() {
            return ctrl.gridOptions.data;
          },
          companies :function(){
            if(ctrl.gridOptions.data.length === 0 && ctrl.creation){
              return ctrl.PrincipalSvc.listCompanies(ctrl.principal.detail.id);
            }
            return ctrl.group.companies;
          }
        }
      })
      .result.then(
        function(sub) {
          ctrl.group= { companies: [sub.legalEntity] };
          ctrl.gridOptions.data = ctrl.gridOptions.data.concat(sub.rows);
          ctrl.gridOptions.totalItems = ctrl.gridOptions.data.length;
        }
      );
  }

  deleteSubEntity(subEntity) {
    var index = this.gridOptions.data.indexOf(subEntity);
    this.gridOptions.data.splice(index, 1);
    this.gridOptions.totalItems = this.gridOptions.data.length;
  }
}

angular.module('app.principal').component('principalGroupSubEntity', {
  templateUrl: require('./principal-group-add-sub-entity.html'),
  controller: PrincipalGroupSubEntityCtrl,
  bindings: {
    principal: '<',
    companies: '<',
    creation: '<',
    group: '<'
  }
});
